<template>
  <div
    class="overflow-hidden rounded-xl border"
    :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
  >
    <div
      class="divide-y"
      :class="[mode === 'dark' ? 'divide-dark-border' : 'divide-border-10']"
    >
      <div v-for="(item, key) in data" :key="key" class="flex items-center">
        <div
          class="w-[241px] border-r sm:w-[160px]"
          :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
        >
          <div class="p-4">
            <span
              class="text-[15px] font-semibold sm:text-[14px]"
              :class="[item.isCheckboxes?.enabled ? 'opacity-0' : '']"
              >{{ item.name }}</span
            >
          </div>
        </div>
        <div class="flex-1">
          <div class="p-4">
            <div
              v-if="item.isCheckboxes?.enabled"
              class="flex items-center gap-4 sm:gap-2"
            >
              <AppCheckbox
                :mode="mode"
                id="ascdi-member"
                title="Member"
                :isDisabled="true"
                v-model="item.isCheckboxes.values.member"
              />
              <AppCheckbox
                :mode="mode"
                id="atn-subscriber"
                title="Subscriber"
                :isDisabled="true"
                v-model="item.isCheckboxes.values.subscriber"
              />
            </div>
            <span              v-else-if="item.isHtml"
              class="text-[15px] font-medium sm:text-[14px]"
              :class="[
                item.value
                  ? ''
                  : mode === 'dark'
                    ? 'text-dark-text'
                    : 'text-black-60',
              ]"
              v-html="item.value || 'Not specified'"
            ></span>
            <span              v-else
              class="text-[15px] font-medium sm:text-[14px]"
              :class="[
                item.value
                  ? ''
                  : mode === 'dark'
                    ? 'text-dark-text'
                    : 'text-black-60',
              ]"
              >{{
                (item.isDate
                  ? $formatDateTime(item.value).date +
                    " " +
                    $formatDateTime(item.value).time
                  : item.value) || "Not specified"
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppCheckbox from "@C/Form/AppCheckbox.vue";

export default {
  name: "RecordDetails",
  props: {
    mode: String,
    data: {
      type: Array,
      default: () => ({
        name: "",
        value: "",
        isCheckboxes: {
          enabled: false,
          values: {
            member: false,
            subscriber: false,
          },
        },
        isDate: false,
      }),
    },
  },
  components: {
    AppCheckbox,
  },
};
</script>
